import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './contact-book-a-call.css'

const ContactBookACall = (props) => {
  return (
    <div className="contact-book-a-call-container1">
      <Helmet>
        <title>Contact-Book-a-Call - ClearPath Digital</title>
        <meta
          property="og:title"
          content="Contact-Book-a-Call - ClearPath Digital"
        />
        <link
          rel="canonical"
          href="https://clearpathdigital.teleporthq.app/contact-book-a-call"
        />
      </Helmet>
      <Navigation></Navigation>
      <main className="contact-page">
        <section className="contact---book-a-call-hero-section">
          <div className="container">
            <div className="hero-card">
              <span className="hero-badge">Ready to Scale?</span>
              <h1 className="hero-title">
                Book Your Free Website Strategy Call
              </h1>
              <p className="contact---book-a-call-hero-subtitle hero-subtitle">
                Stop losing leads to a slow, outdated site. Let&apos;s map out a
                high-converting digital asset that works for your business 24/7.
                No pushy sales, just pure strategy.
              </p>
              <div className="hero-actions">
                <div className="contact-book-a-call-thq-btn-elm1 btn btn-primary btn-lg">
                  <span>Book My Strategy Call</span>
                </div>
              </div>
              <p className="contact---book-a-call-hero-reassurance">
                100% Free • 20 Minutes • Zero Obligation
              </p>
            </div>
          </div>
        </section>
        <section className="contact---book-a-call-contact-form-section1">
          <div className="container">
            <div className="contact---book-a-call-form-wrapper1">
              <div className="form-header">
                <h2 className="section-title">
                  Book Your Website Strategy Call
                </h2>
                <p className="section-content">
                  Let&apos;s discuss how we can transform your business with a
                  high-converting website. Fill out the form below and
                  we&apos;ll get back to you within 24 hours.
                </p>
              </div>
              <form
                id="contactForm"
                action="https://formsubmit.co/igor.d'adhemar@clearpathdigital.co"
                method="POST"
                data-form-id="46635444-9058-480f-9dd7-e75409aa96cb"
                className="strategy-form"
              >
                <input
                  type="hidden"
                  id="thq__subject_nCCk"
                  name="_subject"
                  value="New Website Strategy Call Request"
                  data-form-field-id="thq__subject_nCCk"
                />
                <input
                  type="hidden"
                  id="thq__captcha_r2gx"
                  name="_captcha"
                  value="false"
                  data-form-field-id="thq__captcha_r2gx"
                />
                <input
                  type="hidden"
                  id="thq__template_qlQL"
                  name="_template"
                  value="table"
                  data-form-field-id="thq__template_qlQL"
                />
                <input
                  type="hidden"
                  id="thq__next_gi5g"
                  name="_next"
                  value="https://yourdomain.com/thank-you"
                  data-form-field-id="thq__next_gi5g"
                />
                <div className="contact---book-a-call-form-group2">
                  <label
                    htmlFor="fullName"
                    className="contact---book-a-call-form-label1"
                  >
                    <span className="contact-book-a-call-thq-label-icon-elm1">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                          <circle r="4" cx="12" cy="7"></circle>
                        </g>
                      </svg>
                    </span>
                    <span>Full Name</span>
                    <span className="contact-book-a-call-thq-required-mark-elm1">
                      *
                    </span>
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="true"
                    required="true"
                    placeholder="John Doe"
                    data-form-field-id="fullName"
                    className="contact---book-a-call-form-input1"
                  />
                </div>
                <div className="contact---book-a-call-form-group2">
                  <label
                    htmlFor="email"
                    className="contact---book-a-call-form-label1"
                  >
                    <span className="contact-book-a-call-thq-label-icon-elm2">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                          <rect
                            x="2"
                            y="4"
                            rx="2"
                            width="20"
                            height="16"
                          ></rect>
                        </g>
                      </svg>
                    </span>
                    <span>Email Address</span>
                    <span className="contact-book-a-call-thq-required-mark-elm2">
                      *
                    </span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required="true"
                    placeholder="john@company.com"
                    data-form-field-id="email"
                    className="contact---book-a-call-form-input1"
                  />
                </div>
                <div className="contact---book-a-call-form-group2">
                  <label
                    htmlFor="company"
                    className="contact---book-a-call-form-label1"
                  >
                    <span className="contact-book-a-call-thq-label-icon-elm3">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M12 10h.01M12 14h.01M12 6h.01M16 10h.01M16 14h.01M16 6h.01M8 10h.01M8 14h.01M8 6h.01M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"></path>
                          <rect
                            x="4"
                            y="2"
                            rx="2"
                            width="16"
                            height="20"
                          ></rect>
                        </g>
                      </svg>
                    </span>
                    <span>Company Name</span>
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    placeholder="Your Company Ltd"
                    data-form-field-id="company"
                    className="contact---book-a-call-form-input1"
                  />
                </div>
                <div className="contact---book-a-call-form-group2">
                  <label
                    htmlFor="website"
                    className="contact---book-a-call-form-label1"
                  >
                    <span className="contact-book-a-call-thq-label-icon-elm4">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle r="10" cx="12" cy="12"></circle>
                          <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                        </g>
                      </svg>
                    </span>
                    <span>Current Website URL (Optional)</span>
                  </label>
                  <input
                    type="url"
                    id="website"
                    name="website"
                    placeholder="https://yourwebsite.com"
                    data-form-field-id="website"
                    className="contact---book-a-call-form-input1"
                  />
                </div>
                <div className="contact---book-a-call-form-group2">
                  <label
                    htmlFor="budget"
                    className="contact---book-a-call-form-label1"
                  >
                    <span className="contact-book-a-call-thq-label-icon-elm5">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </span>
                    <span>Project Budget</span>
                  </label>
                  <select
                    id="budget"
                    name="budget"
                    data-form-field-id="budget"
                    className="contact---book-a-call-form-select"
                  >
                    <option value="true">Select your budget range</option>
                    <option value="under-5k">Under €500</option>
                    <option value="5k-15k">€500 - €800</option>
                    <option value="15k-30k">€800 - €1,200</option>
                    <option value="30k-plus">€1,200+</option>
                  </select>
                </div>
                <div className="contact---book-a-call-form-group2">
                  <label
                    htmlFor="message"
                    className="contact---book-a-call-form-label1"
                  >
                    <span className="contact-book-a-call-thq-label-icon-elm6">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </span>
                    <span>Project Details / Message</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    placeholder="Tell us about your project, goals, timeline, and any specific requirements..."
                    data-form-field-id="message"
                    className="contact---book-a-call-form-textarea1"
                  ></textarea>
                </div>
                <div className="contact---book-a-call-form-group2 checkbox-group">
                  <div className="checkbox-wrapper">
                    <input
                      type="checkbox"
                      id="gdprConsent"
                      name="gdpr_consent"
                      required="true"
                      data-form-field-id="gdprConsent"
                      className="contact---book-a-call-form-checkbox2"
                    />
                    <label
                      htmlFor="gdprConsent"
                      className="contact---book-a-call-checkbox-label1"
                    >
                      <span>
                        {' '}
                        I agree to the
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <Link
                        to="/gdpr-legal"
                        className="contact-book-a-call-thq-privacy-policy-elm"
                      >
                        privacy policy
                      </Link>
                      <span>
                        {' '}
                        and consent to be contacted regarding my inquiry
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </label>
                  </div>
                </div>
                <div className="form-actions">
                  <button
                    id="thq_button_lSv6"
                    name="button"
                    type="submit"
                    data-form-field-id="thq_button_lSv6"
                    className="submit-button btn btn-primary btn-lg"
                  >
                    <span>Send Request</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            id="successOverlay"
            className="success-overlay contact---book-a-call-message-overlay"
          >
            <div className="contact---book-a-call-message-content">
              <button
                id="successCloseBtn"
                aria-label="Close success message"
                className="close-button"
              >
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
              <div className="contact---book-a-call-success-icon contact---book-a-call-message-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="message-title">Request Sent Successfully!</h3>
              <p className="contact---book-a-call-message-text">
                Thank you for reaching out. We&apos;ll review your information
                and get back to you within 24 hours to schedule your website
                strategy call.
              </p>
            </div>
          </div>
          <div
            id="errorOverlay"
            className="error-overlay contact---book-a-call-message-overlay"
          >
            <div className="contact---book-a-call-message-content">
              <button
                id="errorCloseBtn"
                aria-label="Close error message"
                className="close-button"
              >
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
              <div className="contact---book-a-call-message-icon contact---book-a-call-error-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="message-title">Oops! Something Went Wrong</h3>
              <p className="contact---book-a-call-message-text">
                We couldn&apos;t submit your request. Please check your internet
                connection and try again, or email us directly at
                contact@youragency.com
              </p>
            </div>
          </div>
        </section>
        <section className="contact---book-a-call-steps-section">
          <div className="container">
            <div className="steps-header">
              <h2 className="section-title">What to expect on our call</h2>
              <p className="section-subtitle">
                We value your time. Here is our 20-minute roadmap.
              </p>
            </div>
            <div className="steps-list">
              <div className="contact---book-a-call-step-item">
                <div className="contact---book-a-call-step-number">
                  <span>01</span>
                </div>
                <div className="step-content">
                  <h3 className="section-subtitle">Discovery (5 min)</h3>
                  <p className="section-content">
                    We dive into your current business challenges and what your
                    website is (or isn&apos;t) doing for you right now.
                  </p>
                </div>
              </div>
              <div className="contact---book-a-call-step-item">
                <div className="contact---book-a-call-step-number">
                  <span>02</span>
                </div>
                <div className="step-content">
                  <h3 className="section-subtitle">Goal Alignment (10 min)</h3>
                  <p className="section-content">
                    We review your target audience and define the specific
                    conversions needed to drive ROI for your specific industry.
                  </p>
                </div>
              </div>
              <div className="contact---book-a-call-step-item">
                <div className="contact---book-a-call-step-number">
                  <span>03</span>
                </div>
                <div className="step-content">
                  <h3 className="section-subtitle">
                    Solution &amp; Next Steps (5 min)
                  </h3>
                  <p className="section-content">
                    We showcase relevant examples and provide a clear,
                    no-pressure roadmap for your project launch.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="prep-section">
          <div className="container">
            <div className="prep-card">
              <h2 className="section-title">Prepare for Success</h2>
              <p className="section-subtitle">
                To make our time as productive as possible, please have these
                ready:
              </p>
              <ul className="prep-list">
                <li className="prep-item">
                  <div className="contact---book-a-call-flex-row">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <path d="m9 12 2 2 4-4"></path>
                    </svg>
                    <span>
                      Current website URL (if applicable) for a quick live
                      audit.
                    </span>
                  </div>
                </li>
                <li className="prep-item">
                  <div className="contact---book-a-call-flex-row">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <path d="m9 12 2 2 4-4"></path>
                    </svg>
                    <span>
                      A clear definition of your primary target audience.
                    </span>
                  </div>
                </li>
                <li className="prep-item">
                  <div className="contact---book-a-call-flex-row">
                    <svg
                      fill="none"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <path d="m9 12 2 2 4-4"></path>
                    </svg>
                    <span>Your #1 business goal for the next 6-12 months.</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="contact---book-a-call-trust-section">
          <div className="container">
            <div className="contact---book-a-call-trust-grid">
              <div className="trust-column">
                <div className="trust-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8h-2c0-2.67-.67-4.67-2-6a5 5 0 0 0-8 4v11h2Z"></path>
                    <path d="M13 15l3 3 5-5"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Proven Process</h3>
                <p className="section-content">
                  Strategy → Design → Launch. A predictable path to a
                  high-performing website.
                </p>
              </div>
              <div className="trust-column">
                <div className="trust-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Expertise</h3>
                <p className="section-content">
                  Trusted by SMBs, local service businesses, and fast-growing
                  startups across the EU.
                </p>
              </div>
              <div className="trust-column">
                <div className="trust-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">GDPR Secure</h3>
                <p className="section-content">
                  Full EU compliance. Your data is handled with the highest
                  privacy standards.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="audit" className="contact---book-a-call-final-cta-section">
          <div className="container">
            <div className="contact---book-a-call-cta-card">
              <h2 className="section-title">Not ready to book yet?</h2>
              <p className="section-content">
                Get a free, no-obligation website audit delivered to your inbox,
                or reach out directly with your questions.
              </p>
              <div className="cta-buttons">
                <a href="mailto:hello@agency.com?subject=">
                  <div className="btn btn-lg btn-secondary">
                    <span>Get Free Audit</span>
                  </div>
                </a>
                <div className="btn btn-link">
                  <span>Back to Booking</span>
                </div>
              </div>
              <p className="cta-privacy">Privacy guaranteed. No spam, ever.</p>
            </div>
          </div>
        </section>
        <div className="contact-book-a-call-container2">
          <div className="contact-book-a-call-container3">
            <Script
              html={`<script defer data-name="contact-form-handler">
(function(){
  const form = document.getElementById("contactForm")
  const successOverlay = document.getElementById("successOverlay")
  const errorOverlay = document.getElementById("errorOverlay")
  const successCloseBtn = document.getElementById("successCloseBtn")
  const errorCloseBtn = document.getElementById("errorCloseBtn")
  let isSubmitting = false

  function showSuccessMessage() {
    successOverlay.classList.add("show")
    errorOverlay.classList.remove("show")

    setTimeout(() => {
      hideSuccessMessage()
    }, 5000)
  }

  function showErrorMessage() {
    errorOverlay.classList.add("show")
    successOverlay.classList.remove("show")

    setTimeout(() => {
      hideErrorMessage()
    }, 5000)
  }

  function hideSuccessMessage() {
    successOverlay.classList.remove("show")
  }

  function hideErrorMessage() {
    errorOverlay.classList.remove("show")
  }

  successCloseBtn.addEventListener("click", hideSuccessMessage)
  errorCloseBtn.addEventListener("click", hideErrorMessage)

  successOverlay.addEventListener("click", (e) => {
    if (e.target === successOverlay) {
      hideSuccessMessage()
    }
  })

  errorOverlay.addEventListener("click", (e) => {
    if (e.target === errorOverlay) {
      hideErrorMessage()
    }
  })

  form.addEventListener("submit", (e) => {
    if (isSubmitting) {
      e.preventDefault()
      return
    }

    const submitButton = form.querySelector(".submit-button")
    const gdprCheckbox = document.getElementById("gdprConsent")

    if (!gdprCheckbox.checked) {
      e.preventDefault()
      showErrorMessage()
      return
    }

    isSubmitting = true
    submitButton.disabled = true
    submitButton.innerHTML = "<span>Sending...</span>"
  })
})()
</script>`}
            ></Script>
          </div>
        </div>
      </main>
      <div className="contact-book-a-call-container4">
        <div className="contact-book-a-call-container5">
          <Script
            html={`<script defer data-name="booking-interactivity">
(function(){
  const timeButtons = document.querySelectorAll('.time-btn');
  const calendarDays = document.querySelectorAll('.calendar-day.active');
  const bookingForm = document.querySelector('.qualification-form');

  // Simple visual feedback for slot selection
  timeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      timeButtons.forEach(b => {
        b.style.backgroundColor = 'var(--color-surface)';
        b.style.color = 'var(--color-on-surface)';
      });
      btn.style.backgroundColor = 'var(--color-primary)';
      btn.style.color = 'var(--color-on-primary)';
    });
  });

  calendarDays.forEach(day => {
    day.addEventListener('click', () => {
      calendarDays.forEach(d => {
        d.style.backgroundColor = 'color-mix(in srgb, var(--color-primary) 5%, transparent)';
        d.style.color = 'var(--color-primary)';
      });
      day.style.backgroundColor = 'var(--color-primary)';
      day.style.color = 'var(--color-on-primary)';
    });
  });

  // Form submission feedback (Visual only, native submission preserved)
  bookingForm.addEventListener('submit', (e) => {
    const submitBtn = bookingForm.querySelector('button[type="submit"]');
    submitBtn.textContent = 'Processing...';
    submitBtn.disabled = true;
    
    // In a real scenario, the form would submit via action="/submit-booking"
    // We just provide visual feedback for this demo
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
      <div className="contact-book-a-call-container6">
        <div className="contact-book-a-call-container7">
          <Script
            html={`<style>
        @keyframes fadeIn {from {opacity: 0;}
to {opacity: 1;}}@keyframes slideUp {from {opacity: 0;
transform: translateY(1.25rem);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="contact-book-a-call-container8">
        <div className="contact-book-a-call-container9">
          <Script
            html={`<script defer data-name="contact-form-validation">
(function(){
const form = document.getElementById('strategyForm');
const successOverlay = document.getElementById('successMessage');
const errorOverlay = document.getElementById('errorMessage');
const closeSuccessBtn = document.getElementById('closeSuccess');
const closeErrorBtn = document.getElementById('closeError');
const projectBrief = document.getElementById('projectBrief');
const charCount = document.getElementById('charCount');

function updateCharCount() {
  const count = projectBrief.value.length;
  charCount.textContent = count;
}

projectBrief.addEventListener('input', updateCharCount);

function validateField(field) {
  if (!field.checkValidity()) {
    field.classList.add('has-error');
    return false;
  } else {
    field.classList.remove('has-error');
    return true;
  }
}

const formInputs = form.querySelectorAll('input, textarea');
formInputs.forEach(input => {
  input.addEventListener('blur', () => {
    if (input.value.length > 0 || input.hasAttribute('required')) {
      validateField(input);
    }
  });

  input.addEventListener('input', () => {
    if (input.classList.contains('has-error')) {
      validateField(input);
    }
  });
});

form.addEventListener('submit', (e) => {
  e.preventDefault();
  
  let isValid = true;
  formInputs.forEach(input => {
    if (!validateField(input)) {
      isValid = false;
    }
  });

  if (!isValid) {
    const firstError = form.querySelector('.has-error');
    if (firstError) {
      firstError.focus();
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }

  const formData = new FormData(form);
  
  fetch(form.action, {
    method: form.method,
    body: formData,
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(response => {
    if (response.ok) {
      successOverlay.classList.add('active');
      form.reset();
      updateCharCount();
      formInputs.forEach(input => input.classList.remove('has-error'));
    } else {
      errorOverlay.classList.add('active');
    }
  })
  .catch(() => {
    errorOverlay.classList.add('active');
  });
});

closeSuccessBtn.addEventListener('click', () => {
  successOverlay.classList.remove('active');
});

closeErrorBtn.addEventListener('click', () => {
  errorOverlay.classList.remove('active');
});

successOverlay.addEventListener('click', (e) => {
  if (e.target === successOverlay) {
    successOverlay.classList.remove('active');
  }
});

errorOverlay.addEventListener('click', (e) => {
  if (e.target === errorOverlay) {
    errorOverlay.classList.remove('active');
  }
});
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default ContactBookACall
